var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M6,2A1,1,0,0,0,5,3V4H4A2,2,0,0,0,2,6V16a2,2,0,0,0,2,2H16a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2H15V3a1,1,0,1,0-2,0V4H7V3A1,1,0,0,0,6,2ZM6,7A1,1,0,0,0,6,9h8a1,1,0,0,0,0-2Z",
    transform: "translate(-2 -2)",
    fill: "#5f6266",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.5d1edf20f8a0bf09ff23cc790a418182.svg";
export { ForwardRef as ReactComponent };